import React from 'react';
import {
  ShowController,
  ShowView,
  TabbedShowLayout,
  Tab,
  DateField,
  ReferenceField,
  TextField,
  ReferenceManyField,
  Labeled,
  Datagrid,
  ListButton,
} from 'react-admin';
import CardActions from '@material-ui/core/CardActions';
import ApproveButton from '../ApproveButton';
import FullNameField from '../General/FullNameField';
import ParsedNumberField from '../ParsedNumberField';
import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';


const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const Actions = ({ basePath, data }) => {
  const adminLevel = getAdminLevel();
  return (
    <CardActions style={cardActionStyle}>
      { [ADMIN_LEVELS.FULL_ADMIN, ADMIN_LEVELS.SUPERVISOR_ADMIN].includes(adminLevel) ?
        <ApproveButton color="primary" recordType="accounts" record={data} /> : undefined
      }
      <ListButton basePath={basePath} />
    </CardActions>
  );
};


export default props => (
  <ShowController {...props}>
    {controllerProps => (
      <ShowView {...props} {...controllerProps} actions={<Actions />}>
        <TabbedShowLayout>
          <Tab label="Basic">
            <TextField source="accountNumber" />
            <ReferenceField label="Account Owner" source="userId" reference="users" linkType="show">
              <FullNameField />
            </ReferenceField>

            <DateField source="createdAt" />

            {controllerProps.record && controllerProps.record.approvedAt ? (
              <DateField source="approvedAt" />
            ) : (
              <Labeled label="Approved at">
                <span>Not Approved</span>
              </Labeled>
            )}
            {controllerProps.record && controllerProps.record.approvedBy && (
              <ReferenceField source="approvedBy" reference="users" linkType="show">
                <FullNameField />
              </ReferenceField>
            )}

            <ReferenceManyField label="Restrictions" reference="accountRestrictions" target="accountNumber" sortable={false}>
              <Datagrid>
                <TextField label="Folio Restriction Id" source="accountRestrictionId" sortable={false} />
                <TextField source="type.description" sortable={false} />
                <TextField source="reason.code" sortable={false} />
                <TextField source="reason.name" sortable={false} />
              </Datagrid>
            </ReferenceManyField>
          </Tab>

          <Tab label="Portfolio">
            <ReferenceField label="End Market Value" reference="accountPerformanceSummary" source="accountNumber" linkType={false}>
              <ParsedNumberField
                source="endMarketValue"
                options={{ style: 'currency', currency: 'USD' }}
              />
            </ReferenceField>
            <ReferenceField label="Cash Balance" reference="accountCashBalance" source="accountNumber" linkType={false}>
              <ParsedNumberField
                source="balanceAvailableForT1Trades"
                options={{ style: 'currency', currency: 'USD' }}
              />
            </ReferenceField>
            <ReferenceManyField label="Positions" reference="accountPositions" target="accountNumber" sortable={false}>
              <Datagrid>
                <TextField source="security.companyName" label="Company Name" />
                <TextField source="security.ticker" label="Ticker" />
                <TextField source="shareQuantity" label="Share Quantity" />
                <TextField source="currentWeight" label="Current Weight" />
                <TextField source="shortTermCostBasis" label="Short Term Cost" />
                <TextField source="longTermCostBasis" label="Long Term Cost" />

                <TextField source="security.instrumentType" label="Instrument Type" />
                <TextField source="security.settlementPeriod" label="Settlement Period" />
              </Datagrid>
            </ReferenceManyField>
          </Tab>

          <Tab label="Transactions">
            <ReferenceManyField
              label="Transactions"
              reference="accountTransactions"
              target="accountNumber"
              sortable={false}
            >
              <Datagrid>
                <DateField source="date" sortable={false} />
                <TextField source="transactionDesc" sortable={false} />
                <TextField source="ticker" sortable={false} />
                <TextField source="symbolName" sortable={false} />
                <ParsedNumberField source="quantity" sortable={false} />
                <ParsedNumberField source="price" sortable={false} />
              </Datagrid>
            </ReferenceManyField>
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    )}
  </ShowController>
);



// WEBPACK FOOTER //
// ./src/components/Account/Show.js